<template>
  <el-dialog
    :close-on-click-modal="false"
    title="余额登记"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  setAccountBalance,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      formData: {
        form: [
          {
            label: '登记时间',
            value: 'registrationDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '金额',
            value: 'balance',
            type: 'input',
            placeholder: '请输入金额',
          },
        ],
        rules: { // 表单验证规则
          registrationDate: [ // 登记时间
            { required: true, message: '请输入登记时间', trigger: 'blur' },
          ],
          balance: [ // 金额
            { required: true, message: '请输入金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await setAccountBalance({
        registrationDate: this.formatDate(form.registrationDate, 1),
        balance: form.balance,
        accountTypeId: this.originData.accountTypeId,
        accountTypeName: this.originData.accountTypeName,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
